import React from 'react';
import { useEffect } from 'react';
import currency from 'currency.js';
import { useDispatch, useSelector } from 'react-redux';

import { formatTransactiontDate } from '../../../../helpers/date/date';
import { fetchReversedTransactionStart } from '../../../../store/actions/WalletAction';

import './styles/cards.css';
import NothingHere from '../../../../images_new/icon/nothing_here.svg?react';

export default function ReversedEarningsCards() {
  const dispatch = useDispatch();
  const reversedTransactions = useSelector((state) => state.wallet.reversedTransactions);

  useEffect(() => {
    dispatch(fetchReversedTransactionStart());
  }, []);

  return (
    <>
      <div className={`cards-container last-card-margin`}>
        {reversedTransactions?.data?.length ? (
          reversedTransactions?.data?.map((transaction, index) => (
            <div className={`statement-card ${index % 2 !== 0 ? 'bg-white' : ''}`}>
              <div className='statement-card-header'>
                <h1
                  className='statement-card-title'
                  dangerouslySetInnerHTML={{ __html: transaction.message }}
                ></h1>
              </div>
              <div className='statement-card-body'>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Reversed on</p>{' '}
                  <p className='statement-text-data'>
                    {formatTransactiontDate(transaction.created_at)}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Pain on</p>{' '}
                  <p className='statement-text-data'>
                    {formatTransactiontDate(transaction?.wallet_payment?.paid_date)}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Description</p>{' '}
                  <p className='statement-text-data'>
                    <span
                      dangerouslySetInnerHTML={{ __html: transaction?.wallet_payment?.message }}
                    ></span>
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Amount</p>{' '}
                  <p className='statement-text-data'>
                    {currency(transaction?.wallet_payment?.user_amount || 0).format()}
                  </p>
                </div>
              </div>
            </div>
          ))
        ) : (
          <>
            <div className='d-flex w-100 justify-content-center mt-3'>
              <NothingHere />
            </div>
          </>
        )}
      </div>
    </>
  );
}
